// InsufficientBalancePage.jsx
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';
import { useBalance } from '../context/BalanceContext';
import { useWallet } from '@solana/wallet-adapter-react';

// Replace the URL below with your actual purchase URL
const purchaseUrl = 'https://phantom.com/tokens/solana/Gc3eJ7fhAaJR2YsxyNs9nCb4HydBiLryKGxghW613sYK';

const InsufficientBalancePage = () => {
  const { publicKey } = useWallet();
  const { tokenBalance } = useBalance();

  useEffect(() => {
    // When both publicKey and tokenBalance are available, automatically process completion
    if (publicKey && tokenBalance) {
      handleProcessComplete();
    }
  }, [publicKey]);

  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve the previous path from state (fallback to '/' if not available)
  const from = location.state?.from?.pathname || '/';

  // When "Already Purchased" button is clicked, navigate back to the original route
  const handleProcessComplete = () => {
    navigate(from, { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#000', // using black as the base color
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="h3" align="center" gutterBottom>
          Insufficient Token Balance
        </Typography>
        <Typography variant="body1" align="center" gutterBottom>
          To access this page, a minimum token balance of 50 is required.<br />
          Please use your Phantom wallet to purchase the necessary tokens.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button
            variant="contained"
            size="large"
            href={purchaseUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              bgcolor: '#0f2027',
              '&:hover': { bgcolor: '#0d1017' },
              px: 4,
              py: 1.5,
            }}
          >
            Purchase with Phantom
          </Button>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          {/* You can add additional buttons or links here if needed */}
        </Box>
      </Container>
    </Box>
  );
};

export default InsufficientBalancePage;
